import { GunInfo } from '@models/gun';

export interface GunField {
  id?: number | null;
  connectorId: string; // 樁體號_槍編號
  gunName: string; // 自訂
  billRuleId: number | null;
  remark: string; // 億電沒有
  number?: string; // A 槍??
}

export interface PileField {
  pileId: number | null;
  pileNum: string;
  pileName: string;
  pileTypeId: number | null;
  belongStationId: number | null;
  guns: GunField[];
  // 億電有，Otto 設計稿沒有
  collectPort: number; // 連接方式; 目前寫死為 1
  // closeStartOne-Four: 電樁關閉1-4開始時間
  // closeFinishOne-Four: 電樁關閉1-4結束時間
}

export interface PileDetailField {
  pileId: number;
  pileNum: string;
  pileName: string;
  pileTypeName: string;
  belongStationName: string;
  belongStationLng: string;
  belongStationLat: string;
  areaName: string;
  pileTypeCatalog: number;
  pileTypeProtocolValue: number;
}

export interface DisableEnableGunField {
  disableId?: number | null;
  pileId: number;
  gunNumbers: string[];
  disableStartTime: 0;
  disableFinishTime: 0;
}

export interface RealtimePileInfo {
  gunInfos: GunInfo[] | null;
  pileMetadataVo: {
    currentMode: string; // AC, DC
    pileTypeCatalog: number;
    gunCount: number;
    gunTypeId: number;
    pileId: number;
    pileName: string;
    pileNo: string;
    pileTypeId: number;
    pileTypeName: string;
    ratingPower: number;
    socketType: string; // J1772, Mennekes, CCS1, CCS2, CHAdeMO
    stationId: number;
    stationName: string;
    pileStatus?: string; // 前端會複製外面的 pileStatus
  } | null;
  pileStatus: string; // Offline, Normal, Abnormal, Unexpected_NoGuns
}

export enum PileStatusEnum {
  Offline = 'Offline',
  Normal = 'Normal',
  Abnormal = 'Unexpected',
  Unexpected_NoGuns = 'Unexpected',
}

export const PROTOCOL_VALUE: { [key: number]: string } = {
  30: 'Model.StandardOCPP1.6',
};

export const CATALOG: { [key: number]: string } = {
  44: 'TITAN',
  45: 'eTreego',
  46: 'Zerova',
  47: 'Oberon',
};

export const catalogValueOptions = Object.keys(CATALOG).map((keyString) => {
  const key = Number(keyString);
  return {
    label: CATALOG[key],
    value: key,
  };
});

export const CURRENT_TYPE: { [key: number]: string } = {
  1: 'AC',
  2: 'DC',
};

export const AC_GUN_TYPE: { [key: number]: string } = {
  1: 'J1772',
  2: 'Mennekes',
};

export const DC_GUN_TYPE: { [key: number]: string } = {
  1: 'CCS-1',
  2: 'CCS-2',
  3: 'CHAdeMO',
};

// 英文開頭，方便後端新增列舉
export type SeriesValue =
  | 'SmartSeriesAC7kW'
  | 'SmartSeriesDC180kW'
  | 'SmartSeriesDC360kW'
  | 'L2SeriesAC7kW'
  | 'L2SeriesAC17kW'
  | 'L3SeriesDC30kW'
  | 'L3SeriesDC120kW'
  | 'DWYA301DC30kW'
  | 'DSYA122DC120kW'
  | 'DOYC362DC360kW'
  | 'AWSC770AC7kW'
  | 'V3DC50kW'
  | 'V3DC90kW'
  | 'V3DC120kW'
  | 'V3DC150kW'
  | 'V3DC180kW'
  | 'Series50ADC50kW'
  | 'Series50BDC50kW'
  | 'Series50BDC90kW'
  | 'Series50BDC120kW';

export const allSeries: {
  [key in SeriesValue]: { value: SeriesValue; label: string };
} = {
  SmartSeriesAC7kW: {
    value: 'SmartSeriesAC7kW',
    label: 'Model.SmartSeriesAC7kW',
  },
  SmartSeriesDC180kW: {
    value: 'SmartSeriesDC180kW',
    label: 'Model.SmartSeriesDC180kW',
  },
  SmartSeriesDC360kW: {
    value: 'SmartSeriesDC360kW',
    label: 'Model.SmartSeriesDC360kW',
  },
  L2SeriesAC7kW: {
    value: 'L2SeriesAC7kW',
    label: 'Model.L2SeriesAC7kW',
  },
  L2SeriesAC17kW: {
    value: 'L2SeriesAC17kW',
    label: 'Model.L2SeriesAC17kW',
  },
  L3SeriesDC30kW: {
    value: 'L3SeriesDC30kW',
    label: 'Model.L3SeriesDC30kW',
  },
  L3SeriesDC120kW: {
    value: 'L3SeriesDC120kW',
    label: 'Model.L3SeriesDC120kW',
  },
  DWYA301DC30kW: {
    value: 'DWYA301DC30kW',
    label: 'DWYA301 DC-30kW',
  },
  DSYA122DC120kW: {
    value: 'DSYA122DC120kW',
    label: 'DSYA122 DC-120kW',
  },
  DOYC362DC360kW: {
    value: 'DOYC362DC360kW',
    label: 'DOYC362 DC-360kW',
  },
  AWSC770AC7kW: {
    value: 'AWSC770AC7kW',
    label: 'AWSC770 AC-7kW',
  },
  V3DC50kW: {
    value: 'V3DC50kW',
    label: 'V3 DC-50kW',
  },
  V3DC90kW: {
    value: 'V3DC90kW',
    label: 'V3 DC-90kW',
  },
  V3DC120kW: {
    value: 'V3DC120kW',
    label: 'V3 DC-120kW',
  },
  V3DC150kW: {
    value: 'V3DC150kW',
    label: 'V3 DC-150kW',
  },
  V3DC180kW: {
    value: 'V3DC180kW',
    label: 'V3 DC-180kW',
  },
  Series50ADC50kW: {
    value: 'Series50ADC50kW',
    label: '50A DC-50kW',
  },
  Series50BDC50kW: {
    value: 'Series50BDC50kW',
    label: '50B DC-50kW',
  },
  Series50BDC90kW: {
    value: 'Series50BDC90kW',
    label: '50B DC-90kW',
  },
  Series50BDC120kW: {
    value: 'Series50BDC120kW',
    label: '50B DC-120kW',
  },
};

export const allSeriesOptions = Object.values(allSeries).map(
  (thisSeries) => thisSeries,
);

export const catalogSeriesMap: {
  [key: number]: { value: string; label: string }[];
} = {
  44: [
    {
      value: allSeries.SmartSeriesAC7kW.value,
      label: allSeries.SmartSeriesAC7kW.label,
    },
    {
      value: allSeries.SmartSeriesDC180kW.value,
      label: allSeries.SmartSeriesDC180kW.label,
    },
    {
      value: allSeries.SmartSeriesDC360kW.value,
      label: allSeries.SmartSeriesDC360kW.label,
    },
    {
      value: allSeries.V3DC50kW.value,
      label: allSeries.V3DC50kW.label,
    },
    {
      value: allSeries.V3DC90kW.value,
      label: allSeries.V3DC90kW.label,
    },
    {
      value: allSeries.V3DC120kW.value,
      label: allSeries.V3DC120kW.label,
    },
    {
      value: allSeries.V3DC150kW.value,
      label: allSeries.V3DC150kW.label,
    },
    {
      value: allSeries.V3DC180kW.value,
      label: allSeries.V3DC180kW.label,
    },
  ],
  45: [
    {
      value: allSeries.L2SeriesAC7kW.value,
      label: allSeries.L2SeriesAC7kW.label,
    },
    {
      value: allSeries.L2SeriesAC17kW.value,
      label: allSeries.L2SeriesAC17kW.label,
    },
    {
      value: allSeries.L3SeriesDC30kW.value,
      label: allSeries.L3SeriesDC30kW.label,
    },
    {
      value: allSeries.L3SeriesDC120kW.value,
      label: allSeries.L3SeriesDC120kW.label,
    },
  ],
  46: [
    {
      value: allSeries.DWYA301DC30kW.value,
      label: allSeries.DWYA301DC30kW.label,
    },
    {
      value: allSeries.DSYA122DC120kW.value,
      label: allSeries.DSYA122DC120kW.label,
    },
    {
      value: allSeries.DOYC362DC360kW.value,
      label: allSeries.DOYC362DC360kW.label,
    },
    {
      value: allSeries.AWSC770AC7kW.value,
      label: allSeries.AWSC770AC7kW.label,
    },
  ],
  47: [
    {
      value: allSeries.Series50ADC50kW.value,
      label: allSeries.Series50ADC50kW.label,
    },
    {
      value: allSeries.Series50BDC50kW.value,
      label: allSeries.Series50BDC50kW.label,
    },
    {
      value: allSeries.Series50BDC90kW.value,
      label: allSeries.Series50BDC90kW.label,
    },
    {
      value: allSeries.Series50BDC120kW.value,
      label: allSeries.Series50BDC120kW.label,
    },
  ],
};

export interface GunSocketTypeDetails {
  gunSocketTypeConfig: string[];
  partNumber: string;
}

export type Series = GunSocketTypeDetails[];

export interface CatalogSeries {
  [key: string]: Series;
}

export interface CatalogSeriesGunSocketTypePartNumberMap {
  [key: number]: CatalogSeries;
}

export const partNumberMap = {
  AC0070EN025253: {
    partNumber: 'AC0070EN025253',
    gunSocketTypeConfig: [AC_GUN_TYPE[1]],
    series: 'SmartSeriesAC7kW',
    catalog: 44,
  },
  AC0070EN025254: {
    partNumber: 'AC0070EN025254',
    gunSocketTypeConfig: [AC_GUN_TYPE[2]],
    series: 'SmartSeriesAC7kW',
    catalog: 44,
  },
  'DH-DC1800SG56-G': {
    partNumber: 'DH-DC1800SG56-G',
    gunSocketTypeConfig: [DC_GUN_TYPE[1], DC_GUN_TYPE[2]],
    series: 'SmartSeriesDC180kW',
    catalog: 44,
  },
  DC3600CN04301: {
    partNumber: 'DC3600CN04301',
    gunSocketTypeConfig: [DC_GUN_TYPE[1], DC_GUN_TYPE[2]],
    series: 'SmartSeriesDC360kW',
    catalog: 44,
  },
  DC3600CN04302: {
    partNumber: 'DC3600CN04302',
    gunSocketTypeConfig: [DC_GUN_TYPE[1], DC_GUN_TYPE[1]],
    series: 'SmartSeriesDC360kW',
    catalog: 44,
  },
  DC3600CN04303: {
    partNumber: 'DC3600CN04303',
    gunSocketTypeConfig: [DC_GUN_TYPE[2], DC_GUN_TYPE[2]],
    series: 'SmartSeriesDC360kW',
    catalog: 44,
  },
  DC3600CN04304: {
    partNumber: 'DC3600CN04304',
    gunSocketTypeConfig: [DC_GUN_TYPE[2], DC_GUN_TYPE[1]],
    series: 'SmartSeriesDC360kW',
    catalog: 44,
  },
  DC0500JI04202: {
    partNumber: 'DC0500JI04202',
    gunSocketTypeConfig: [DC_GUN_TYPE[3]],
    series: 'V3DC50kW',
    catalog: 44,
  },
  DC0900JI042: {
    partNumber: 'DC0900JI042',
    gunSocketTypeConfig: [DC_GUN_TYPE[3]],
    series: 'V3DC90kW',
    catalog: 44,
  },
  DC1200JI042: {
    partNumber: 'DC1200JI042',
    gunSocketTypeConfig: [DC_GUN_TYPE[3]],
    series: 'V3DC120kW',
    catalog: 44,
  },
  DC1500JI042: {
    partNumber: 'DC1500JI042',
    gunSocketTypeConfig: [DC_GUN_TYPE[3]],
    series: 'V3DC150kW',
    catalog: 44,
  },
  DC1800JI042: {
    partNumber: 'DC1800JI042',
    gunSocketTypeConfig: [DC_GUN_TYPE[3]],
    series: 'V3DC180kW',
    catalog: 44,
  },
  'L2-U2': {
    partNumber: 'L2-U2',
    gunSocketTypeConfig: [AC_GUN_TYPE[1]],
    series: 'L2SeriesAC7kW',
    catalog: 45,
  },
  'L2-S280SAE': {
    partNumber: 'L2-S280SAE',
    gunSocketTypeConfig: [AC_GUN_TYPE[1]],
    series: 'L2SeriesAC17kW',
    catalog: 45,
  },
  'L3-W30SS': {
    partNumber: 'L3-W30SS',
    gunSocketTypeConfig: [DC_GUN_TYPE[1], DC_GUN_TYPE[2]],
    series: 'L3SeriesDC30kW',
    catalog: 45,
  },
  'L3-S120PSS1M-CCS1': {
    partNumber: 'L3-S120PSS1M-CCS1',
    gunSocketTypeConfig: [DC_GUN_TYPE[1]],
    series: 'L3SeriesDC120kW',
    catalog: 45,
  },
  'L3-S120PSS1M-CCS2': {
    partNumber: 'L3-S120PSS1M-CCS2',
    gunSocketTypeConfig: [DC_GUN_TYPE[2]],
    series: 'L3SeriesDC120kW',
    catalog: 45,
  },
  DWYA301: {
    partNumber: 'DWYA301',
    gunSocketTypeConfig: [DC_GUN_TYPE[1], DC_GUN_TYPE[2]],
    series: 'DWYA301DC30kW',
    catalog: 46,
  },
  DSYA122: {
    partNumber: 'DSYA122',
    gunSocketTypeConfig: [DC_GUN_TYPE[1], DC_GUN_TYPE[2]],
    series: 'DSYA122DC120kW',
    catalog: 46,
  },
  DOYC362: {
    partNumber: 'DOYC362',
    gunSocketTypeConfig: [DC_GUN_TYPE[1], DC_GUN_TYPE[2]],
    series: 'DOYC362DC360kW',
    catalog: 46,
  },
  AWSC770: {
    partNumber: 'AWSC770',
    gunSocketTypeConfig: [AC_GUN_TYPE[1]],
    series: 'AWSC770AC7kW',
    catalog: 46,
  },
  DC0500JI170052: {
    partNumber: 'DC0500JI170052',
    gunSocketTypeConfig: [DC_GUN_TYPE[3]],
    series: 'Series50ADC50kW',
    catalog: 47,
  },
  DC0500JI238052: {
    partNumber: 'DC0500JI238052',
    gunSocketTypeConfig: [DC_GUN_TYPE[3]],
    series: 'Series50BDC50kW',
    catalog: 47,
  },
  DC0900JI238082: {
    partNumber: 'DC0900JI238082',
    gunSocketTypeConfig: [DC_GUN_TYPE[3]],
    series: 'Series50BDC90kW',
    catalog: 47,
  },
  DC1200JI238082: {
    partNumber: 'DC1200JI238082',
    gunSocketTypeConfig: [DC_GUN_TYPE[3]],
    series: 'Series50BDC120kW',
    catalog: 47,
  },
};

export const catalogSeriesGunSocketTypePartNumberMap: CatalogSeriesGunSocketTypePartNumberMap =
  {
    44: {
      SmartSeriesAC7kW: [
        {
          gunSocketTypeConfig: partNumberMap.AC0070EN025253.gunSocketTypeConfig,
          partNumber: partNumberMap.AC0070EN025253.partNumber,
        },
        {
          gunSocketTypeConfig: partNumberMap.AC0070EN025254.gunSocketTypeConfig,
          partNumber: partNumberMap.AC0070EN025254.partNumber,
        },
      ],
      SmartSeriesDC180kW: [
        {
          gunSocketTypeConfig:
            partNumberMap['DH-DC1800SG56-G'].gunSocketTypeConfig,
          partNumber: partNumberMap['DH-DC1800SG56-G'].partNumber,
        },
      ],
      SmartSeriesDC360kW: [
        {
          gunSocketTypeConfig: partNumberMap.DC3600CN04301.gunSocketTypeConfig,
          partNumber: partNumberMap.DC3600CN04301.partNumber,
        },
        {
          gunSocketTypeConfig: partNumberMap.DC3600CN04302.gunSocketTypeConfig,
          partNumber: partNumberMap.DC3600CN04302.partNumber,
        },
        {
          gunSocketTypeConfig: partNumberMap.DC3600CN04303.gunSocketTypeConfig,
          partNumber: partNumberMap.DC3600CN04303.partNumber,
        },
        {
          gunSocketTypeConfig: partNumberMap.DC3600CN04304.gunSocketTypeConfig,
          partNumber: partNumberMap.DC3600CN04304.partNumber,
        },
      ],
      V3DC50kW: [
        {
          gunSocketTypeConfig: partNumberMap.DC0500JI04202.gunSocketTypeConfig,
          partNumber: partNumberMap.DC0500JI04202.partNumber,
        },
      ],
      V3DC90kW: [
        {
          gunSocketTypeConfig: partNumberMap.DC0500JI04202.gunSocketTypeConfig,
          partNumber: partNumberMap.DC0500JI04202.partNumber,
        },
      ],
      V3DC120kW: [
        {
          gunSocketTypeConfig: partNumberMap.DC0500JI04202.gunSocketTypeConfig,
          partNumber: partNumberMap.DC0500JI04202.partNumber,
        },
      ],
      V3DC150kW: [
        {
          gunSocketTypeConfig: partNumberMap.DC0500JI04202.gunSocketTypeConfig,
          partNumber: partNumberMap.DC0500JI04202.partNumber,
        },
      ],
      V3DC180kW: [
        {
          gunSocketTypeConfig: partNumberMap.DC1800JI042.gunSocketTypeConfig,
          partNumber: partNumberMap.DC1800JI042.partNumber,
        },
      ],
    },
    45: {
      L2SeriesAC7kW: [
        {
          gunSocketTypeConfig: partNumberMap['L2-U2'].gunSocketTypeConfig,
          partNumber: partNumberMap['L2-U2'].partNumber,
        },
      ],
      L2SeriesAC17kW: [
        {
          gunSocketTypeConfig: partNumberMap['L2-S280SAE'].gunSocketTypeConfig,
          partNumber: partNumberMap['L2-S280SAE'].partNumber,
        },
      ],
      L3SeriesDC30kW: [
        {
          gunSocketTypeConfig: partNumberMap['L3-W30SS'].gunSocketTypeConfig,
          partNumber: partNumberMap['L3-W30SS'].partNumber,
        },
      ],
      L3SeriesDC120kW: [
        {
          gunSocketTypeConfig:
            partNumberMap['L3-S120PSS1M-CCS1'].gunSocketTypeConfig,
          partNumber: partNumberMap['L3-S120PSS1M-CCS1'].partNumber,
        },
        {
          gunSocketTypeConfig:
            partNumberMap['L3-S120PSS1M-CCS2'].gunSocketTypeConfig,
          partNumber: partNumberMap['L3-S120PSS1M-CCS2'].partNumber,
        },
      ],
    },
    46: {
      DWYA301DC30kW: [
        {
          gunSocketTypeConfig: partNumberMap.DWYA301.gunSocketTypeConfig,
          partNumber: partNumberMap.DWYA301.partNumber,
        },
      ],
      DSYA122DC120kW: [
        {
          gunSocketTypeConfig: partNumberMap.DSYA122.gunSocketTypeConfig,
          partNumber: partNumberMap.DSYA122.partNumber,
        },
      ],
      DOYC362DC360kW: [
        {
          gunSocketTypeConfig: partNumberMap.DOYC362.gunSocketTypeConfig,
          partNumber: partNumberMap.DOYC362.partNumber,
        },
      ],
      AWSC770AC7kW: [
        {
          gunSocketTypeConfig: partNumberMap.AWSC770.gunSocketTypeConfig,
          partNumber: partNumberMap.AWSC770.partNumber,
        },
      ],
    },
    47: {
      Series50ADC50kW: [
        {
          gunSocketTypeConfig: partNumberMap.DC0500JI170052.gunSocketTypeConfig,
          partNumber: partNumberMap.DC0500JI170052.partNumber,
        },
      ],
      Series50BDC50kW: [
        {
          gunSocketTypeConfig: partNumberMap.DC0500JI238052.gunSocketTypeConfig,
          partNumber: partNumberMap.DC0500JI238052.partNumber,
        },
      ],
      Series50BDC90kW: [
        {
          gunSocketTypeConfig: partNumberMap.DC0900JI238082.gunSocketTypeConfig,
          partNumber: partNumberMap.DC0900JI238082.partNumber,
        },
      ],
      Series50BDC120kW: [
        {
          gunSocketTypeConfig: partNumberMap.DC1200JI238082.gunSocketTypeConfig,
          partNumber: partNumberMap.DC1200JI238082.partNumber,
        },
      ],
    },
  };

export function getSeriesLabel(value: keyof typeof allSeries) {
  return allSeries[value]?.label || '-';
}
